import React from 'react';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import {
  FacebookShareButton, TwitterShareButton, RedditShareButton, WhatsappShareButton,
  FacebookIcon, TwitterIcon, RedditIcon, WhatsappIcon
} from 'react-share';
import { Box } from '@mui/system';
import { DialogContent, DialogContentText } from '@mui/material';
 
export default function PopupSocialShare(props) {
  const { open, onClose, courseURL, courseName} = props;

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle style={{maxWidth: '400px'}}>{courseName}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Share this course on:
        </DialogContentText>
      </DialogContent>
      <List sx={{ pt: 0 }}>
        <ListItem autoFocus sx={{display: 'flex', justifyContent:'center', alignItems:'center'}} >
          <Box sx={{marginRight: '15px'}}>
            <FacebookShareButton url={courseURL} quote={"Check this new Course!"} hashtag={"CoursePool"} >
                <FacebookIcon round />
            </FacebookShareButton>
          </Box>

          <Box sx={{marginRight: '15px'}}>
            <TwitterShareButton url={courseURL} title={"Check this new Course!"} hashtag={"CoursePool"} className="mx-2">
              <TwitterIcon round />
            </TwitterShareButton>
          </Box>

          <Box sx={{marginRight: '15px'}}>
            <RedditShareButton url={courseURL} title={"Check this new Course!"} className="mx-2">
              <RedditIcon round />
            </RedditShareButton>
          </Box>

          <Box>
            <WhatsappShareButton url={courseURL} title={"Check this new Course!"} className="mx-2">
              <WhatsappIcon round />
            </WhatsappShareButton>
          </Box>

        </ListItem>
      </List>
    </Dialog>
  );
}

PopupSocialShare.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

